<template>
  <div>
    <blocking-loader  :show="loaded === false">Przygotowywanie Formularza</blocking-loader>
    <div v-if="modelLoaded && loaded && categoryGroup === 'main'">
      <CommonForm
        :rawSchemas="rawSchemas"
        :model="model"
        :id="`main`"
        :rules="rules"
        @saveField="handleSaveField"
        @addCollectionItem="handleAddCollectionItem"
        @removeCollectionItem="handleRemoveCollectionItem"
        :schemaType="SCHEMA_NAME_MAIN_VALUATION_comp"
      >
      </CommonForm>
    </div>
    <CommonForm
      v-if="loaded && categoryGroup === 'appraisal'"
      :rawSchemas="rawSchemas"
      :model="model"
      :id="`main-info`"
      :rules="rules"
      @saveField="handleSaveField"
      @addCollectionItem="handleAddCollectionItem"
      @removeCollectionItem="handleRemoveCollectionItem"
      :schemaType="SCHEMA_NAME_APPRAISA_comp"
    >
    </CommonForm>

    <Tabs
      v-if="loaded && categoryGroup === 'appraisal'"
      :tabs-data="schemaTabs"
      ref="formTabs"
      class="task-form"
      :key="`realEatatesTabs-${realEstates.length}`"
      v-on:clickedTab="reactToTabChange"
      :allow-delete="true"
      @tabs-delete-item="handleDeleteRealEstate"
      :topDistance="topTabsDistance + 44"
    >
      <div v-for="(realEstate, index) in realEstates" :slot="`form-${realEstate.id}-${index}` "
           :key="`realEstate-${realEstate.id}-${index}`" v-show="activeTabIndex === index">
        <real-estate
          v-if="loaded && !reloading"
          :id="`realEstateContainer-${realEstate.id}-${index}`"
          :realEstate="realEstate"
          :model="model"
          :rawSchemas="rawSchemas"
          :rules="rules"
          :service="service"
          :currently-opened="currentlyOpened(index)"
          :real-estate-index="index"
          :topTabsDistance="topTabsDistance"
          @delete-land-register="(e) => $emit('delete-land-register', e)"
          @addLandRegisterCall="addLandRegisterTransReceiver"
          @saveField="handleSaveField"
          @addCollectionItem="handleAddCollectionItem"
          @removeCollectionItem="handleRemoveCollectionItem"
        ></real-estate>
      </div>
    </Tabs>
  </div>

</template>
<script>
import BlockingLoader from '@/components/share/BlockingLoader.vue'
import Tabs from '@/components/share/tabs/Tabs.vue'
import RealEstate from '../form/forms/realEstate.vue'
import {
  FORM_EVENT_ADD_COLLECTION_ITEM,
  FORM_EVENT_REMOVE_COLLECTION_ITEM,
  FORM_EVENT_SAVE_FIELD
} from '../form/utils/formEventsConstants.js'
import CommonForm from '../form/forms/CommonForm.vue'
import {SCHEMA_NAME_APPRAISAL, SCHEMA_NAME_MAIN_VALUATION} from '../form/forms/schemaNames.js'
import realEstateKindMixin from '../summary/realEstateKindMixin.js'

export default {
  components: {
    CommonForm,
    BlockingLoader,
    RealEstate,
    Tabs
  },
  mixins: [realEstateKindMixin],
  props: {
    model: {},
    rawSchemas: {},
    rules: {},
    categoryGroup: {type: String, required: true},
    service: {},
    addLandRegisterCaller: {},
    schema: {},
    rulesTemp: {},
    modelLoaded: {},
    topTabsDistance: {type: Number, required: true},
  },
  data () {
    return {
      schemaTabs: [],
      loaded: false,
      activeTabIndex: 0,
      reloading: false
    }
  },
  computed: {
    realEstates () {
      return this.model.hasOwnProperty('realEstates') && Array.isArray(this.model.realEstates) && this.model.realEstates || []
    },
    SCHEMA_NAME_MAIN_VALUATION_comp () {
      return SCHEMA_NAME_MAIN_VALUATION
    },
    SCHEMA_NAME_APPRAISA_comp () {
      return SCHEMA_NAME_APPRAISAL
    }
  },
  watch: {
    realEstates(prev, next) {
      this.getTabs()
    },
    rules() {
      this.reloading = false
    }
  },
  async mounted () {
    this.getTabs()
    this.loaded = true
  },
  methods: {
    handleSaveField (e) {
      const shouldReloadForm = e.path.split('/')[3] === 'kind'

      if (shouldReloadForm) {
        this.reloading = true;
      }
      this.getTabs()
      this.$emit(FORM_EVENT_SAVE_FIELD, e)
    },
    handleAddCollectionItem (e) {
      this.$emit(FORM_EVENT_ADD_COLLECTION_ITEM, e)
    },
    handleRemoveCollectionItem (e) {
      this.$emit(FORM_EVENT_REMOVE_COLLECTION_ITEM, e)
    },
    currentlyOpened (realEstateIndex) {
      return realEstateIndex === this.activeTabIndex;
    },
    getTabs () {
      if(!this.realEstates[this.activeTabIndex])
        this.activeTabIndex = 0;

      // TODO: schameTabs should be changed to array of objects instead of array of array (xD) because its very error prone and unreadible using element index instead property name
      this.schemaTabs = [
        ...(this.realEstates.map((el,index) => {
          return [
            `form-${el.id}-${index}`,
            `${el.kind ? this.getKindLabel(el.kind) : 'Nieruchomość '+(el.id ? el.id : '')}`,
            index === this.activeTabIndex,
            [`${this.service}.get_task__appraisal__1`],
            [true]
          ]
        }))
      ]
    },
    handleDeleteRealEstate ({tabIndex}) {
      this.$emit('delete-real-estate', {realEstate: this.realEstates[tabIndex]})
    },
    addLandRegisterTransReceiver () {
      let realEstateIndex = this.activeTabIndex
      this.addLandRegisterCaller({realEstateIndex})
      this.getTabs()
    },
    reactToTabChange (tabName) {
      this.activeTabIndex = this.schemaTabs.findIndex(el => el[0] === tabName)
      this.getTabs()
    },
  }
}
</script>
<style>
</style>
